var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobilePhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.375 1H6.625C6.72446 1 6.81984 1.04139 6.89017 1.11507C6.96049 1.18874 7 1.28866 7 1.39286V11.6071C7 11.7113 6.96049 11.8113 6.89017 11.8849C6.81984 11.9586 6.72446 12 6.625 12H1.375C1.27554 12 1.18016 11.9586 1.10983 11.8849C1.03951 11.8113 1 11.7113 1 11.6071V1.39286C1 1.28866 1.03951 1.18874 1.10983 1.11507C1.18016 1.04139 1.27554 1 1.375 1ZM3.625 10.4286H4.375C4.47446 10.4286 4.56984 10.47 4.64016 10.5436C4.71049 10.6173 4.75 10.7172 4.75 10.8214C4.75 10.9256 4.71049 11.0255 4.64016 11.0992C4.56984 11.1729 4.47446 11.2143 4.375 11.2143H3.625C3.52554 11.2143 3.43016 11.1729 3.35984 11.0992C3.28951 11.0255 3.25 10.9256 3.25 10.8214C3.25 10.7172 3.28951 10.6173 3.35984 10.5436C3.43016 10.47 3.52554 10.4286 3.625 10.4286ZM6.25 9.64286H1.75V1.78571H6.25V9.64286Z",
    fill: "#2A2D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilePhone);
export default __webpack_public_path__ + "static/media/mobilePhone.62c4cc5cb76934c25a296869483be424.svg";
export { ForwardRef as ReactComponent };